/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PublicCourseGroupWithBookingInfoEntity } from '../models/PublicCourseGroupWithBookingInfoEntity';
import type { PublicInstructorEntity } from '../models/PublicInstructorEntity';
import type { PublicMediaGalleryItemEntity } from '../models/PublicMediaGalleryItemEntity';
import type { PublicMeetingEntity } from '../models/PublicMeetingEntity';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CourseGroupPublicService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all Course Groups including their Booking info
     * @param organizationId
     * @returns PublicCourseGroupWithBookingInfoEntity Course Groups have been returned
     * @throws ApiError
     */
    public courseGroupPublicControllerGetCourseGroupsV1(
        organizationId: string,
    ): CancelablePromise<Array<PublicCourseGroupWithBookingInfoEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/public/courseGroup',
            query: {
                'organizationId': organizationId,
            },
        });
    }
    /**
     * Get a Course Group including its Booking info
     * @param courseGroupId
     * @returns PublicCourseGroupWithBookingInfoEntity Course Group has been returned
     * @throws ApiError
     */
    public courseGroupPublicControllerGetCourseGroupV1(
        courseGroupId: string,
    ): CancelablePromise<PublicCourseGroupWithBookingInfoEntity> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/public/courseGroup/{courseGroupId}',
            path: {
                'courseGroupId': courseGroupId,
            },
        });
    }
    /**
     * Get all Media Gallery Items of a Course Group
     * @param courseGroupId
     * @returns PublicMediaGalleryItemEntity Media Gallery Items have been returned
     * @throws ApiError
     */
    public courseGroupPublicControllerGetCourseGroupMediaGalleryItemsV1(
        courseGroupId: string,
    ): CancelablePromise<Array<PublicMediaGalleryItemEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/public/courseGroup/{courseGroupId}/mediaGalleryItems',
            path: {
                'courseGroupId': courseGroupId,
            },
            errors: {
                404: `Course Group has not been found`,
            },
        });
    }
    /**
     * Get Course Group Meetings
     * @param courseGroupId
     * @returns PublicMeetingEntity Course Group Meetings have been returned
     * @throws ApiError
     */
    public courseGroupPublicControllerGetCourseGroupMeetingsV1(
        courseGroupId: string,
    ): CancelablePromise<Array<PublicMeetingEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/public/courseGroup/{courseGroupId}/meetings',
            path: {
                'courseGroupId': courseGroupId,
            },
            errors: {
                404: `Course Group has not been found`,
            },
        });
    }
    /**
     * Get Course Group Meeting Instructors
     * @param courseGroupId
     * @returns PublicInstructorEntity Course Group Meeting Instructors have been returned
     * @throws ApiError
     */
    public courseGroupPublicControllerGetCourseGroupMeetingInstructorsV1(
        courseGroupId: string,
    ): CancelablePromise<Array<PublicInstructorEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/public/courseGroup/{courseGroupId}/meetingInstructors',
            path: {
                'courseGroupId': courseGroupId,
            },
            errors: {
                404: `Course Group has not been found`,
            },
        });
    }
}
